import React, { useState } from 'react';

import PropTypes from 'prop-types';

import request, { USER_RIGHTS } from '../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { Button } from './css';
import ViewOrderDetails from '../../../iotOrderFulfillmentDashboard/components/viewOrderDetails';

const ViewOrder = ({ orderData, fetchOrders }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { viewOrderButtonLabel }
  } = localizedStrings;

  const profile = request.getProfile();
  const userProfileRole = profile && profile.role.name;
  const userRights = userProfileRole && USER_RIGHTS[userProfileRole];

  const [isOderDetailsOpen, setIsOrderDetailsOpen] = useState(false);

  return (
    <>
    
      {isOderDetailsOpen && (
        <ViewOrderDetails
          closeViewDetails={setIsOrderDetailsOpen}
          orderData={orderData}
          userRights={userRights}
          fetchOrders={fetchOrders}
        />
      )}
      <Button
        className="action-button"
        onClick={() => setIsOrderDetailsOpen(true)}
      >
        {viewOrderButtonLabel}
      </Button>
    </>
  );
};

ViewOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default ViewOrder;
